<template>
    <div>
        <header class="header">
            <a href="javascript:;" @click="goBack"
               class="back">返回</a>
            <div class="h_label">
                {{titleText}}
            </div>
            <a href="javascript: void(0)"
               class="menu"
               :class="{active : isActive}"
               @click="loadNav"
               ></a>
        </header>
        <nav class="t-nav" :class="{active : isActive}">
            <ul>
                <li><a :href="headUrl.mdd_url"
                       class="home">首页</a></li>
                <li><a :href="headUrl.search_url "
                       class="search">搜索</a></li>
                <li><a :href="headUrl.search_url_ddcategory "
                       class="category">分类</a></li>
                <li><a :href="headUrl.cart_url "
                       class="cart">购物车</a></li>
                <li><a :href="headUrl.home_url"
                       class="user">我的当当</a></li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'ddheader',
    props: ['title'],
    data () {
        return {
            isActive:false,
            headUrl:headUrl,
            titleText:this.title
        }
    },
    methods: {
        loadNav () {
            this.isActive= !this.isActive;
        },
        goBack () {
             this.$router.go(-1)
        }
    }
}
</script>

<style>
/** 顶部导航 **/

.header {
    z-index: 5;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    line-height: 2.2rem;
    background-color: #fff;
    color: #333;
}

.header .back {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    height: 2.2rem;
    padding-left: 1.5rem;
    background: url(../assets/coreimages/back.png) no-repeat .75rem center;
    background-size: auto .75rem;
    font-size: 0;
    width: .5rem;
    overflow: hidden;
    text-indent: -999rem;
}

.header .menu {
    z-index: 2;
    position: absolute;
    top: 0;
    right: 0;
    width: 2rem;
    height: 2.2rem;
    background: url(../assets/coreimages/menu.png) no-repeat center;
    background-size: 1.1rem;
    line-height: 2.2rem;
    font-size: .7rem;
    -webkit-transition: background .3s;
    transition: background .3s;
    overflow: hidden;
    text-indent: -999rem;
}

.header .menu.active {
    background-image: url(../assets/coreimages/menu-active.png);
    background-size: 0.8rem;
}

.header .menu.active:after {
    content: " ";
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: .35rem;
    background: url(../assets/coreimages/connect.png) no-repeat center 0;
}

.header .h_label,
.header h1 {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: static;
    height: 2.2rem;
    text-align: center;
    font-size: .85rem;
    font-weight: normal;
    color: #333;
    padding: 0 2rem;
    border-bottom: 1px solid #d8d8d8;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.header .h_label em,
.header h1 em {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.t-nav {
    width: 100%;
    height: 0;
    overflow: hidden;
    text-align: center;
    line-height: 0;
    background-color: #eee;
    font-size: .6rem;
    -webkit-transition: height .3s;
    transition: height .3s;
    position: relative;
    z-index:9999;
}

.t-nav.active {
    height: 2.5rem;
    border-bottom: 1px solid #d8d8d8;
}

.t-nav ul {
    display: block;
    list-style: none;
}

.t-nav ul:after {
    content: "";
    display: block;
    clear: both;
    height: 0;
}

.t-nav ul li {
    display: inline-block;
    float: left;
    width: 20%;
}

.t-nav ul li a {
    display: inline-block;
    width: 100%;
    padding: 1.5rem 0 .1rem;
    background: url(../assets/coreimages/h-home.png) no-repeat center .3rem;
    background-size: 1.1rem;
    line-height: .8rem;
    color: #4d525d;
}

.t-nav ul li .home {
    background-image: url(../assets/coreimages/h-home.png);
}

.t-nav ul li .search {
    background-image: url(../assets/coreimages/h-search.png);
}

.t-nav ul li .category {
    background-image: url(../assets/coreimages/h-category.png);
}

.t-nav ul li .cart {
    background-image: url(../assets/coreimages/h-cart.png);
}

.t-nav ul li .user {
    background-image: url(../assets/coreimages/h-user.png);
}
</style>


// WEBPACK FOOTER //
// header.vue?a678fee8